const deinitializeTree = (prevState, { treeId, plugins }) => {
  const treeState = prevState[treeId];
  if (!treeState) {
    return prevState;
  }

  for (const plugin of Object.values(plugins)) {
    plugin.tearDownTreeState && plugin.tearDownTreeState(treeState);
  }

  const state = { ...prevState };
  delete state[treeId];
  return state;
};
export default deinitializeTree;
